<template>
  <section class="relative pb-0">
    <tilted-background :disabled="didUserJustLoginOrSignup">
      <div class="container pb-8 l:pb-2">
        <div class="pb-2 relative flex z-10 flex-col justify-between m:flex-row pt-6 l:pt-16 l:pb-1 l:mb-6">
          <div class="m:w-7/12 l:w-6/12 pb-8 m:pb-12 m:mr-6">
            <copy-section-connect
              :inviter-name="inviterName"
              :users-email="usersEmail"
              :is-user-logged-in="isUserLoggedIn"
              :did-user-just-login-or-signup="didUserJustLoginOrSignup"
            />
            <div class="m:w-2/3">
              <input-text
                v-if="didUserJustLoginOrSignup"
                placeholder="eg. Julia"
                class="invitee-form__input mb-4 l:mb-8"
                name="invitee_name"
                :required="true"
                :label="$t('Name')"
                @input="removeInvalidChars"
                v-model.trim="inviteeName"
              />
              <buttons-section-connect
                full-width
                personalise
                :signup-headline="signupHeadline"
                :login-headline="loginHeadline"
                :disabled="didUserJustLoginOrSignup ? !inviteeName.length : false"
                :invitee-name="inviteeName"
                :inviter-name="inviterName"
                :invite-code="inviteCode"
                :show-login="!isUserLoggedIn"
                :show-signup="!isUserLoggedIn"
                :show-logout-link="!didUserJustLoginOrSignup"
              />
            </div>
          </div>
          <accept-image v-if="didUserJustLoginOrSignup" class="m:w-5/12 l:w-6/12 m:pl-1 m:pt-8 l:pt-0 l:pl-4" />
          <invite-image v-else class="m:w-5/12 l:w-6/12 m:pl-1 m:pt-8 l:pt-0 l:pl-20" />
        </div>
      </div>
    </tilted-background>
  </section>
</template>

<script>
import InviteImage from "@/pages/organisations/components/connect/invite-image"
import ButtonsSectionConnect from "@/pages/organisations/components/connect/buttons-section-connect"
import CopySectionConnect from "@/pages/organisations/components/copy-section-connect"
import AcceptImage from "@/pages/organisations/components/connect/accept-image"
import TiltedBackground from "@/component-library/tilted-background"
import { mapGetters } from "vuex"
import { getLastPathParam, getSearchParam } from "@/utils/location"
import InputText from "@/shared/form/input-text"

export default {
  name: "HeroSection",
  components: {
    InputText,
    InviteImage,
    ButtonsSectionConnect,
    TiltedBackground,
    CopySectionConnect,
    AcceptImage
  },
  props: {
    inviterName: {
      type: String,
      default: ""
    },
    signupHeadline: {
      type: String,
      default: ""
    },
    loginHeadline: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      inviteeName: "",
      removeEmoticonsRegex:
        /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g
    }
  },
  computed: {
    ...mapGetters(["isUserLoggedIn", "usersEmail"]),
    didUserJustLoginOrSignup() {
      return getSearchParam("fromLoginSignup") === "true"
    },
    inviteCode() {
      return getLastPathParam()
    }
  },
  methods: {
    removeInvalidChars() {
      this.inviteeName = this.inviteeName.replace(this.removeEmoticonsRegex, "")
    }
  },
  i18n: {
    messages: {
      en: {
        Name: "Name"
      },
      de: {
        Name: "Dein Vorname"
      }
    }
  }
}
</script>
